<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <template v-slot:activator="{ on }">
        <v-btn @click.stop="dialog = true" large text>VIDEO CONFERENCE</v-btn>
      </template>

      <v-card
        tile
        outlined
        style="background-color: black;border-radius: 26px; border: 3px solid #a07800"
      >
        <v-card-title>
          <span class="headline">VIDEO CONFERENCING</span>
        </v-card-title>
        <!-- <v-toolbar dark color="primary" short> -->
        <v-btn icon dark @click="cancelDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- <h1>Welcome to FirebaseRTC!</h1> -->
        <v-card
          tile
          outlined
          style="background-color: black;border-radius: 26px; border: 3px solid #18CAE6; height: 100%;"
          class="ma-3"
        >
          <div id="buttons">
            <div>
              <v-btn
                id="cameraBtn"
                small
                rounded
                class="ma-2"
                @click="openUserMedia"
                :disabled="cameraDisabled"
              >
                <v-icon>mdi-camera</v-icon>
                <v-icon>mdi-microphone</v-icon>
                <span class="ma-2">OPEN CAMERA & MICROPHONE</span>
              </v-btn>
              <!-- ***************** -->
              <v-btn
                v-if="videoOn"
                id="videoBtn"
                small
                rounded
                class="ma-2"
                @click="toggleVideo"
              >
                <v-icon>mdi-video</v-icon>
              </v-btn>
              <v-btn
                v-if="!videoOn"
                id="videoBtn"
                small
                rounded
                class="ma-2"
                @click="toggleVideo"
              >
                <v-icon>mdi-video-off</v-icon>
              </v-btn>
              <v-btn id="micBtn" small rounded class="ma-2">
                <v-icon>mdi-microphone</v-icon>
              </v-btn>
            </div>
            <div>
              <v-btn
                id="createBtn"
                small
                rounded
                class="ma-2"
                @click="createRoom"
                :disabled="createBtnDisabled"
              >
                <v-icon>mdi-account-multiple-plus</v-icon>
                <!-- <v-icon>mdi-microphone</v-icon> -->
                <span class="ma-2">CREATE ROOM</span>
              </v-btn>
            </div>
            <div>
              <v-dialog v-model="dialog2" mx-width="700">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="red lighten-2"
                    dark
                    v-on="on"
                    id="joinBtn"
                    small
                    rounded
                    class="ma-2"
                    @click="joinRoom"
                    :disabled="joinBtnDisabled"
                  >
                    <v-icon>mdi-account-multiple</v-icon>JOIN ROOM
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title primary-title>Join Room</v-card-title>

                  <v-divider></v-divider>
                  <v-card-text>
                    <v-text-field
                      v-model="roomId"
                      outlined
                      class="ma-2"
                      label="Input an ID for room to join:"
                    ></v-text-field>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="green"
                      text
                      id="confirmJoinBtn"
                      @click="joinRoomById"
                      :disabled="!roomId"
                      >JOIN</v-btn
                    >
                    <v-btn color="red" text @click="closeJoinDialog"
                      >CLOSE</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- <v-btn
                id="joinBtn"
                small
                rounded
                class="ma-2"
                @click="joinRoom"
                :disabled="joinBtnDisabled"
              >-->
              <!-- <v-icon>mdi-account-multiple</v-icon> -->
              <!-- <v-icon>mdi-microphone</v-icon> -->
              <!-- JOIN ROOM -->
              <!-- </v-btn> -->
            </div>
            <div>
              <v-btn
                id="hangupBtn"
                small
                rounded
                class="ma-2"
                @click="hangUp"
                :disabled="hangUpBtnDisabled"
              >
                <v-icon>mdi-phone-off-outline</v-icon>
                <!-- <v-icon>mdi-microphone</v-icon> -->
                END CALL
              </v-btn>
            </div>
          </div>
          <div v-if="roomId">
            <span id="currentRoom"
              >Current room is {{ roomId }} - You are the {{ position }}</span
            >
          </div>
          <div id="videos">
            <video
              id="localVideo"
              :src="localStream"
              muted
              autoplay
              playsinline
            ></video>
            <video
              id="remoteVideo"
              :src="remoteStream"
              autoplay
              playsinline
            ></video>
          </div>
          <div id="join"></div>
        </v-card>

        <!-- 
         
        
        <div
          class="mdc-dialog"
          id="room-dialog"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="my-dialog-title"
          aria-describedby="my-dialog-content"
        >
          <div class="mdc-dialog__container">
            <div class="mdc-dialog__surface">
              <h2 class="mdc-dialog__title" id="my-dialog-title">Join room</h2>
              <div class="mdc-dialog__content" id="my-dialog-content">
                Enter ID for room to join:
                <div class="mdc-text-field">
                  <input type="text" id="room-id" class="mdc-text-field__input" />
                  <label class="mdc-floating-label" for="my-text-field">Room ID</label>
                  <div class="mdc-line-ripple"></div>
                </div>
              </div>
              <footer class="mdc-dialog__actions">
                <button
                  type="button"
                  class="mdc-button mdc-dialog__button"
                  data-mdc-dialog-action="no"
                >
                  <span class="mdc-button__label">Cancel</span>
                </button>
                <button
                  id="confirmJoinBtn"
                  type="button"
                  class="mdc-button mdc-dialog__button"
                  data-mdc-dialog-action="yes"
                >
                  <span class="mdc-button__label">Join</span>
                </button>
              </footer>
            </div>
          </div>
          <div class="mdc-dialog__scrim"></div>
        </div>-->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 *
 *
 * *******THIS COMPONENT IS HIGHLY EXPERIMENTAL ***********
 *
 *
 */

import * as firebase from "firebase";
export default {
  props: ["matter"],
  data() {
    return {
      dialog: false,
      dialog2: false,
      cameraDisabled: false,
      createBtnDisabled: true,
      joinBtnDisabled: true,
      hangUpBtnDisabled: true,
      position: null,
      peerConnection: null,
      localStream: null,
      remoteStream: null,
      roomDialog: null,
      roomId: null,
      configuration: {
        iceServers: [
          {
            urls: [
              "stun:stun1.l.google.com:19302",
              "stun:stun2.l.google.com:19302"
            ]
          }
        ],
        iceCandidatePoolSize: 10
      },
      videoOn: true
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    }
  },
  watch: {},
  methods: {
    async cancelDialog() {
      if (this.remoteStream) {
        await this.remoteStream.getTracks().forEach(track => track.stop());
      }
      if (this.peerConnection) {
        console.log("peerConnection to be closed:", this.peerConnection);
        await this.peerConnection.close();
      }
      if (this.localStream) {
        await this.localStream.getTracks().forEach(track => track.stop());
      }
      // document.querySelector('#localVideo').srcObject = null;
      this.localStream = null;
      // document.querySelector('#remoteVideo').srcObject = null;
      this.remoteStream = null;
      this.cameraDisabled = false;
      // document.querySelector('#joinBtn').disabled = true;
      this.joinBtnDisabled = true;
      // document.querySelector('#createBtn').disabled = true;
      this.createBtnDisabled = true;
      // document.querySelector('#hangupBtn').disabled = true;
      this.hangUpBtnDisabled = true;
      // document.querySelector('#currentRoom').innerText = '';
      this.position = null;

      // // Delete room on hangup

      if (this.position === "caller") {
        if (this.roomId) {
          const db = firebase.firestore();
          const roomRef = db.collection("rooms").doc(this.roomId);
          const calleeCandidates = await roomRef
            .collection("calleeCandidates")
            .get();
          calleeCandidates.forEach(async candidate => {
            await candidate.ref.delete();
          });
          const callerCandidates = await roomRef
            .collection("callerCandidates")
            .get();
          callerCandidates.forEach(async candidate => {
            await candidate.ref
              .delete()
              .then(() => {
                roomRef.delete;
                this.roomId = null;
              })
              .catch(e => console.error(e));
          });
          // await roomRef.delete();
        }
      }

      navigator.mediaDevices.getUserMedia({
        video: false,
        audio: false
      });
      this.dialog = false;
      // const tracks = this.localStream.getTracks();
      // tracks.forEach(track => {
      //   track.stop();
      // });
    },
    closeJoinDialog() {
      this.dialog2 = false;
      this.joinBtnDisabled = false;
      this.createBtnDisabled = false;
    },
    toggleVideo() {
      let tracks = this.localStream.getTracks();
      console.log("tracks: ", tracks);
      tracks.forEach(track => {
        if (track.kind === "video") {
          // this.videoTrack = track;
          console.log(track);
          track.enabled = !track.enabled;
          this.videoOn = !this.videoOn;
        }
      });
    },
    async openUserMedia(e) {
      console.log(e);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true
      });

      // async getConnectedDevices (type) {
      const devices = await navigator.mediaDevices.enumerateDevices();
      console.log("available devices: ", devices);

      document.querySelector("#localVideo").srcObject = stream;

      // localStream = stream;
      this.localStream = stream;
      // remoteStream = new MediaStream();
      this.remoteStream = new MediaStream();
      document.querySelector("#remoteVideo").srcObject = this.remoteStream;

      console.log("Stream:", document.querySelector("#localVideo").srcObject);
      // document.querySelector('#cameraBtn').disabled = true;
      this.cameraDisabled = true;
      // document.querySelector('#joinBtn').disabled = false;
      this.joinBtnDisabled = false;
      // document.querySelector('#createBtn').disabled = false;
      this.createBtnDisabled = false;
      // document.querySelector('#hangupBtn').disabled = false;
      this.hangUpBtnDisabled = false;
    },
    async createRoom() {
      this.createBtnDisabled = true;
      this.joinBtnDisabled = true;
      const db = firebase.firestore();
      const roomRef = await db.collection("rooms").doc();
      console.log(
        "Create this.peerConnection with configuration: ",
        this.configuration
      );
      let configuration = this.configuration;
      let peerConnection = null;
      // peerConnection = new RTCPeerConnection(configuration);
      this.peerConnection = new RTCPeerConnection(configuration);
      peerConnection = this.peerConnection;
      function registerPeerConnectionListeners() {
        peerConnection.addEventListener("icegatheringstatechange", () => {
          console.log(
            `ICE gathering state changed: ${peerConnection.iceGatheringState}`
          );
        });

        peerConnection.addEventListener("connectionstatechange", () => {
          console.log(
            `Connection state change: ${peerConnection.connectionState}`
          );
        });

        peerConnection.addEventListener("signalingstatechange", () => {
          console.log(
            `Signaling state change: ${peerConnection.signalingState}`
          );
        });

        peerConnection.addEventListener("iceconnectionstatechange ", () => {
          console.log(
            `ICE connection state change: ${peerConnection.iceConnectionState}`
          );
        });
      }

      registerPeerConnectionListeners();
      this.localStream.getTracks().forEach(track => {
        peerConnection.addTrack(track, this.localStream);
      });
      // Code for collecting ICE candidates below
      const callerCandidatesCollection = roomRef.collection("callerCandidates");
      peerConnection.addEventListener("icecandidate", event => {
        if (!event.candidate) {
          console.log("Got final candidate!");
          return;
        }
        console.log("Got candidate: ", event.candidate);
        callerCandidatesCollection.add(event.candidate.toJSON());
      });
      // Code for collecting ICE candidates above
      // Code for creating a room below
      const offer = await peerConnection.createOffer();
      await peerConnection.setLocalDescription(offer);
      console.log("Created offer:", offer);
      const roomWithOffer = {
        offer: {
          type: offer.type,
          sdp: offer.sdp
        }
      };
      await roomRef.set(roomWithOffer);
      this.roomId = roomRef.id;
      console.log(`New room created with SDP offer. Room ID: ${roomRef.id}`);
      // document.querySelector(
      //   "#currentRoom"
      // ).innerText = `Current room is ${roomRef.id} - You are the caller!`;
      this.position = "caller!";
      // // Code for creating a room above

      peerConnection.addEventListener("track", event => {
        console.log("Got remote track:", event.streams[0]);
        event.streams[0].getTracks().forEach(track => {
          console.log("Add a track to the remoteStream:", track);
          this.remoteStream.addTrack(track);
        });
      });

      // // Listening for remote session description below
      roomRef.onSnapshot(async snapshot => {
        const data = snapshot.data();
        if (!peerConnection.currentRemoteDescription && data && data.answer) {
          console.log("Got remote description: ", data.answer);
          const rtcSessionDescription = new RTCSessionDescription(data.answer);
          await peerConnection.setRemoteDescription(rtcSessionDescription);
        }
      });
      // // Listening for remote session description above

      // // Listen for remote ICE candidates below
      roomRef.collection("calleeCandidates").onSnapshot(snapshot => {
        snapshot.docChanges().forEach(async change => {
          if (change.type === "added") {
            let data = change.doc.data();
            console.log(
              `Got new remote ICE candidate: ${JSON.stringify(data)}`
            );
            await peerConnection.addIceCandidate(new RTCIceCandidate(data));
          }
        });
      });
      // // Listen for remote ICE candidates above
    },
    joinRoom() {
      // document.querySelector('#createBtn').disabled = true;
      this.createBtnDisabled = true;
      // document.querySelector('#joinBtn').disabled = true;
      this.joinBtnDisabled = true;
      // document.querySelector('#confirmJoinBtn').
      //     addEventListener('click', async () => {
      //       roomId = document.querySelector('#room-id').value;
      //       console.log('Join room: ', roomId);
      //       document.querySelector(
      //           '#currentRoom').innerText = `Current room is ${roomId} - You are the callee!`;
      //       await joinRoomById(roomId);
      //     }, {once: true});
      // roomDialog.open();
    },
    async joinRoomById() {
      console.log(this.roomId);
      const db = firebase.firestore();
      const roomRef = db.collection("rooms").doc(`${this.roomId}`);
      const roomSnapshot = await roomRef.get();
      console.log("Got room:", roomSnapshot.exists);
      function registerPeerConnectionListeners(peerConnection) {
        peerConnection.addEventListener("icegatheringstatechange", () => {
          console.log(
            `ICE gathering state changed: ${peerConnection.iceGatheringState}`
          );
        });

        peerConnection.addEventListener("connectionstatechange", () => {
          console.log(
            `Connection state change: ${peerConnection.connectionState}`
          );
        });

        peerConnection.addEventListener("signalingstatechange", () => {
          console.log(
            `Signaling state change: ${peerConnection.signalingState}`
          );
        });

        peerConnection.addEventListener("iceconnectionstatechange ", () => {
          console.log(
            `ICE connection state change: ${peerConnection.iceConnectionState}`
          );
        });
      }

      if (roomSnapshot.exists) {
        console.log(
          "Create PeerConnection with configuration: ",
          this.configuration
        );
        this.peerConnection = new RTCPeerConnection(this.configuration);
        let peerConnection = this.peerConnection;

        registerPeerConnectionListeners(peerConnection);
        this.localStream.getTracks().forEach(track => {
          peerConnection.addTrack(track, this.localStream);
        });
        this.position = "callee";

        // Code for collecting ICE candidates below
        const calleeCandidatesCollection = roomRef.collection(
          "calleeCandidates"
        );
        peerConnection.addEventListener("icecandidate", event => {
          if (!event.candidate) {
            console.log("Got final candidate!");
            return;
          }
          console.log("Got candidate: ", event.candidate);
          calleeCandidatesCollection.add(event.candidate.toJSON());
        });
        // Code for collecting ICE candidates above

        peerConnection.addEventListener("track", event => {
          console.log("Got remote track:", event.streams[0]);
          event.streams[0].getTracks().forEach(track => {
            console.log("Add a track to the remoteStream:", track);
            this.remoteStream.addTrack(track);
          });
        });

        // Code for creating SDP answer below
        const offer = roomSnapshot.data().offer;
        console.log("Got offer:", offer);
        await peerConnection.setRemoteDescription(
          new RTCSessionDescription(offer)
        );
        const answer = await peerConnection.createAnswer();
        console.log("Created answer:", answer);
        await peerConnection.setLocalDescription(answer);

        const roomWithAnswer = {
          answer: {
            type: answer.type,
            sdp: answer.sdp
          }
        };
        await roomRef.update(roomWithAnswer);
        //   // Code for creating SDP answer above

        // Listening for remote ICE candidates below
        roomRef.collection("callerCandidates").onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            if (change.type === "added") {
              let data = change.doc.data();
              console.log(
                `Got new remote ICE candidate: ${JSON.stringify(data)}`
              );
              await peerConnection.addIceCandidate(new RTCIceCandidate(data));
            }
          });
        });
        //   // Listening for remote ICE candidates above
      }
    },
    async hangUp() {
      // const tracks = document
      //   .querySelector("#localVideo")
      //   .srcObject.getTracks();
      const tracks = this.localStream.getTracks();
      tracks.forEach(track => {
        track.stop();
      });
      if (this.remoteStream) {
        this.remoteStream.getTracks().forEach(track => track.stop());
      }
      if (this.peerConnection) {
        console.log("peerConnection to be closed:", this.peerConnection);
        this.peerConnection.close();
      }
      // document.querySelector('#localVideo').srcObject = null;
      this.localStream = null;
      // document.querySelector('#remoteVideo').srcObject = null;
      this.remoteStream = null;
      this.cameraDisabled = false;
      // document.querySelector('#joinBtn').disabled = true;
      this.joinBtnDisabled = true;
      // document.querySelector('#createBtn').disabled = true;
      this.createBtnDisabled = true;
      // document.querySelector('#hangupBtn').disabled = true;
      this.hangUpBtnDisabled = true;
      // document.querySelector('#currentRoom').innerText = '';
      this.position = null;

      // // Delete room on hangup

      // if (this.position === "caller") {
      if (this.roomId) {
        const db = firebase.firestore();
        const roomRef = db.collection("rooms").doc(this.roomId);
        const calleeCandidates = await roomRef
          .collection("calleeCandidates")
          .get();
        calleeCandidates.forEach(async candidate => {
          await candidate.ref.delete();
        });
        const callerCandidates = await roomRef
          .collection("callerCandidates")
          .get();
        callerCandidates.forEach(async candidate => {
          await candidate.ref.delete();
        });
        await roomRef.delete();
        this.roomId = null;
        // }
      }
      navigator.mediaDevices.getUserMedia({
        video: false,
        audio: false
      });
      // document.location.reload(true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
